import * as React from "react";
import Collapse from "@mui/material/Collapse";
import Link from "@mui/material/Link";
import { TransitionGroup } from "react-transition-group";
import { Box, Chip, Grid, Paper, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RichContentViewer from "../../../Shared/RichContentViewer";
import { ChevronRight, FiberManualRecord, Forum } from "@mui/icons-material";
import { getWeight, getWeightLabel, WEIGHT_COLOR, STATUS_CONFIG, PROJECT_TYPE_CHIP } from "../../constants";

function renderItem({ each }) {
  return <RichContentViewer content={each.description} />;
}

export { getWeight, getWeightLabel, STATUS_CONFIG };

export default function WebviewV2({ each, createOrLoadDiscussionCb }) {
  const [toggle, setToggle] = React.useState(false);
  const weight = getWeight(each);

  const statusColor = STATUS_CONFIG[each.status]?.color || "default";
  const borderColorMap = { info: "info.main", warning: "warning.main", success: "success.main", default: "grey.400" };

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 1,
        borderRadius: 2,
        borderLeft: 3,
        borderColor: borderColorMap[statusColor] || "grey.400",
        border: "1px solid #e0e0e0",
        borderLeftWidth: 3,
        borderLeftColor: borderColorMap[statusColor] || "grey.400",
        transition: "box-shadow 0.2s",
        "&:hover": { boxShadow: 2 },
      }}
    >
      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton size="small" onClick={() => setToggle(!toggle)} sx={{ p: 0.5 }}>
            {toggle ? <ExpandMoreIcon fontSize="small" color="action" /> : <ChevronRight fontSize="small" color="action" />}
          </IconButton>

          <Link
            color="primary"
            onClick={() => createOrLoadDiscussionCb(each)}
            underline="hover"
            sx={{ fontWeight: 600, cursor: "pointer", fontSize: 13, minWidth: 40 }}
          >
            #{each.projectNumber}
          </Link>

          <Typography variant="body2" fontWeight={500} noWrap sx={{ flex: 1 }}>
            {each.title}
          </Typography>

          {/* Minimal chips */}
          <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", flexShrink: 0 }}>
            {each.projectType && PROJECT_TYPE_CHIP[each.projectType] && (
              <Chip
                size="small"
                color={PROJECT_TYPE_CHIP[each.projectType].color}
                label={PROJECT_TYPE_CHIP[each.projectType].label}
                sx={{ fontWeight: 600, fontSize: 11, height: 22 }}
              />
            )}
            <Chip
              size="small"
              color={STATUS_CONFIG[each.status]?.color || "default"}
              variant="outlined"
              label={STATUS_CONFIG[each.status]?.label || each.status || "Open"}
              sx={{ fontSize: 11, height: 22 }}
            />
            <Chip
              size="small"
              color={WEIGHT_COLOR(weight)}
              variant="outlined"
              label={getWeightLabel(weight)}
              sx={{ fontSize: 11, height: 22 }}
            />
            <IconButton
              size="small" color="primary"
              onClick={() => createOrLoadDiscussionCb(each)}
              title="Open Discussion"
              sx={{ p: 0.5 }}
            >
              <Forum sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <TransitionGroup>
        {toggle && (
          <Collapse>
            <Box sx={{ px: 3, pb: 2, pt: 0 }}>{renderItem({ each })}</Box>
          </Collapse>
        )}
      </TransitionGroup>
    </Paper>
  );
}
